module.exports = __webpack_public_path__ + "8e7c4aed4b0df0aaade4701ccad56c86.svg";